import { SubjectManager } from "../utils/subject-manager";

export const paramsCardEventsService = new SubjectManager();
